 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('trsHeightModule', []).directive('trsHeight', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function(scope, iElement, iAttrs) {


             function contentHeigth() {
                 // $timeout(() => {
                 let windowHeight = window.innerHeight;
                 let top = $(".content_text_wrap").length ? $(".content_text_wrap").offset().top : 0;
                 $(".content_text_wrap").css({
                     height: windowHeight - top
                 });
                 // });
                 //$(".content_text_wrap").height($(window).height() - ($(".content_text_label").outerHeight(true) + $(".tabBtn").outerHeight(true) + $(".view_head").outerHeight(true)));
             }
             var observe = new MutationObserver((mutations, observe) => {
                 contentHeigth();
             });
             observe.observe(iElement[0], {
                 attributeFilter: ['style'],
                 subtree: true
             });
             scope.$on("getTrsHeight", function(event, data) {
                 contentHeigth();
             });
             window.addEventListener("resize", resize);
             scope.$on("$destroy", function() {
                 window.removeEventListener("resize", resize);
             });
             /**
              * [resize description] 重置窗口
              * @return {[type]} [description]
              */
             function resize() {
                 contentHeigth();
             }
         }
     };
 }]);